import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";

import "./identity.scss";
import Sidebar from "../SideBar/SideBar";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
// import Grid from '@mui/material/Grid';
import Grid from "@mui/material/Grid";
import Loader from "../Loader";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import standard from "../../Img/standard.png";

export default function Identity() {
  return (
    <div className="menu-responsive">
      <div>
        <Header />
        <Loader />
        <div className="main_flx">
          <Sidebar />

          <div style={{ width: "100%" }}>
            <div className="abvbar split_half">
              <h6>Individual Identity Verification</h6>
            </div>
            <div className="split_half mt-30">
              <Grid container spacing={5}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <div className="stan_dard box_bdr">
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <h5>Standard Identity Verification</h5>
                        <p>
                          It only takes 3-5 minutes to verify your account.
                          Complete to unlock deposit and trading permissions.
                          Also, new users will get a chance to earn up to
                          <span>25 USDT !</span>
                        </p>
                        <Link
                          to={"/document-verification"}
                          className="org_btn"
                          style={{
                            padding: "15px 25px",
                            display: "inline-block",
                            borderRadius: "150px",
                            marginTop: "10px",
                          }}
                        >
                          <span> Verify </span>{" "}
                          <svg
                            width="18"
                            height="12"
                            viewBox="0 0 18 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.8258 0.410299C10.7483 0.487672 10.6869 0.579548 10.645 0.680677C10.6031 0.781805 10.5815 0.890203 10.5815 0.999674C10.5815 1.10915 10.6031 1.21754 10.645 1.31867C10.6869 1.4198 10.7483 1.51168 10.8258 1.58905L14.4033 5.16655H1.41516C1.1942 5.16655 0.982289 5.25432 0.826048 5.41057C0.669807 5.56681 0.582031 5.77872 0.582031 5.99967C0.582031 6.22063 0.669807 6.43254 0.826048 6.58878C0.982289 6.74502 1.1942 6.8328 1.41516 6.8328H14.4033L10.8258 10.4103C10.6695 10.5666 10.5817 10.7786 10.5817 10.9997C10.5817 11.2207 10.6695 11.4327 10.8258 11.5891C10.9821 11.7454 11.1941 11.8332 11.4152 11.8332C11.6362 11.8332 11.8482 11.7454 12.0045 11.5891L17.0045 6.58967V6.58905L17.0064 6.58717C17.0837 6.51019 17.145 6.41861 17.1866 6.31775C17.2282 6.2169 17.2494 6.10878 17.2489 5.99967C17.2489 5.7703 17.1564 5.5628 17.0064 5.41217L17.0045 5.4103V5.40967L12.0045 0.410299C11.9272 0.332857 11.8353 0.271422 11.7342 0.229506C11.633 0.18759 11.5246 0.166016 11.4152 0.166016C11.3057 0.166016 11.1973 0.18759 11.0962 0.229506C10.995 0.271422 10.9032 0.332857 10.8258 0.410299Z"
                              fill="white"
                            />
                          </svg>
                        </Link>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={6}
                        xl={6}
                        sx={{ textAlign: "center" }}
                        className="display-3"
                      >
                        <img src={standard} alt="img" />
                      </Grid>
                    </Grid>
                    <div className="b_info">
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.6046 6.47229C12.6665 6.41037 12.7156 6.33686 12.7492 6.25596C12.7827 6.17506 12.7999 6.08835 12.7999 6.00079C12.7999 5.91322 12.7827 5.82651 12.7492 5.74561C12.7156 5.66471 12.6665 5.5912 12.6046 5.52929C12.5427 5.46737 12.4692 5.41825 12.3883 5.38474C12.3074 5.35123 12.2207 5.33398 12.1331 5.33398C12.0455 5.33398 11.9588 5.35123 11.8779 5.38474C11.797 5.41825 11.7235 5.46737 11.6616 5.52929L8.13311 9.05779L6.27111 7.19579C6.14606 7.07074 5.97646 7.00048 5.79961 7.00048C5.62277 7.00048 5.45316 7.07074 5.32811 7.19579C5.20306 7.32084 5.13281 7.49044 5.13281 7.66729C5.13281 7.84413 5.20306 8.01374 5.32811 8.13879L7.66161 10.4723C7.72351 10.5342 7.79701 10.5834 7.87792 10.6169C7.95882 10.6505 8.04554 10.6677 8.13311 10.6677C8.22069 10.6677 8.30741 10.6505 8.38831 10.6169C8.46921 10.5834 8.54272 10.5342 8.60461 10.4723L12.6046 6.47229Z"
                          fill="#8C8C8C"
                          fill-opacity="0.6"
                        />
                        <path
                          d="M9.73729 0.911021C9.12721 0.732785 8.47887 0.732785 7.86879 0.911021L4.05329 2.02452C3.4995 2.18622 3.01308 2.52312 2.66699 2.98469C2.3209 3.44626 2.13381 4.00761 2.13379 4.58452V6.67602C2.13379 8.49472 2.65913 10.2747 3.64663 11.802C4.63414 13.3292 6.04178 14.5387 7.70029 15.285C8.04652 15.4405 8.42175 15.5209 8.80129 15.5209C9.18083 15.5209 9.55606 15.4405 9.90229 15.285C11.5603 14.5386 12.9675 13.3293 13.9547 11.8023C14.942 10.2754 15.4672 8.49581 15.4673 6.67752V4.58402C15.4674 4.00722 15.2803 3.44596 14.9343 2.98446C14.5883 2.52297 14.102 2.18614 13.5483 2.02452L9.73779 0.911521L9.73729 0.911021ZM8.24229 2.19102C8.6083 2.08402 8.99728 2.08402 9.36329 2.19102L13.1738 3.30402C13.4506 3.38491 13.6938 3.55339 13.8668 3.78417C14.0398 4.01495 14.1333 4.2956 14.1333 4.58402V6.67752C14.1333 8.23891 13.6823 9.76708 12.8346 11.0783C11.9869 12.3896 10.7786 13.4281 9.35479 14.069C9.18052 14.1474 8.99162 14.1879 8.80054 14.1879C8.60946 14.1879 8.42056 14.1474 8.24629 14.069C6.82212 13.428 5.61339 12.3893 4.76542 11.0778C3.91745 9.76632 3.46633 8.23779 3.46629 6.67602V4.58452C3.46629 3.99202 3.85729 3.47052 4.42629 3.30452L8.24179 2.19102H8.24229Z"
                          fill="#8C8C8C"
                          fill-opacity="0.6"
                        />
                      </svg>{" "}
                      Your information on Dreamster-Exchange is encrypted.
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <div className="custom_acc box_bdr">
                    <h5>FAQ</h5>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>What is Identity Verification?</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          Identity Verification (KYC) is a process where
                          Dreamster-Exchange verifies your identity through
                          personal documents. It's required to access features
                          like withdrawals and rewards.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <Typography>
                          Why do I need to complete Identity Verification?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          Identity Verification is required to comply with
                          regulations, enhance account security, and unlock key
                          features like withdrawals, bonuses, and rewards.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                      >
                        <Typography>
                          Which documents and information are required for
                          Identity Verification?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          For Identity Verification, you'll need to provide a
                          valid government-issued ID (National ID), proof of
                          address, and a selfie to confirm your identity.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={
                          <svg
                            width="21"
                            height="22"
                            viewBox="0 0 21 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.0332 7.4681C11.0332 7.00786 10.6601 6.63477 10.1999 6.63477C9.73963 6.63477 9.36654 7.00786 9.36654 7.4681V9.9681H6.86654C6.4063 9.9681 6.0332 10.3412 6.0332 10.8015C6.0332 11.2617 6.4063 11.6348 6.86654 11.6348H9.36654V14.1348C9.36654 14.595 9.73963 14.9681 10.1999 14.9681C10.6601 14.9681 11.0332 14.595 11.0332 14.1348V11.6348H13.5332C13.9934 11.6348 14.3665 11.2617 14.3665 10.8015C14.3665 10.3412 13.9934 9.9681 13.5332 9.9681H11.0332V7.4681Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.1999 1.63477C5.13713 1.63477 1.0332 5.7387 1.0332 10.8015C1.0332 15.8642 5.13713 19.9681 10.1999 19.9681C15.2626 19.9681 19.3665 15.8642 19.3665 10.8015C19.3665 5.7387 15.2626 1.63477 10.1999 1.63477ZM2.69987 10.8015C2.69987 6.65917 6.05761 3.30143 10.1999 3.30143C14.3421 3.30143 17.6999 6.65917 17.6999 10.8015C17.6999 14.9437 14.3421 18.3015 10.1999 18.3015C6.05761 18.3015 2.69987 14.9437 2.69987 10.8015Z"
                              fill="#8C8C8C"
                              fill-opacity="0.4"
                            />
                          </svg>
                        }
                        aria-controls="panel4a-content"
                        id="panel4a-header"
                      >
                        <Typography>
                          Where can I find help for issues regarding Identity
                          Verification?
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                          You can find help in the 'Support' section of
                          Dreamster-Exchange or contact customer service
                          directly for assistance with any Identity Verification
                          issues.
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
